import { IconTerminal2, IconTrash, IconX } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import { urlApi } from '../../../api/url.api';
import { getApi } from '../../../api/call.api';
import { toast } from 'sonner';
import PromptResponse from './PromptResponse';
import EditPromptResponse from './EditPromptResponse';
import ConfirmationModal from '../../../components/ConfirmationModal/ConfirmationModal';
import TableComponent from '../../../components/DataTable/TableComponent';

const AddPromptResponse = ({ orgID, orgName }) => {
    const [show, setShow] = useState(false);
    const [activePage, setActivePage] = useState(1);
    const [perPage, setPerPage] = useState(10);

    const [tableData, setTableData] = useState({
        data: [],
        totalCount: 0
    })



    const handleClose = () => {
        setShow(false);
    };
    const handleShow = () => setShow(true);


    function handlePageChange(page) {
        setActivePage(page);
    }

    function handlePerRowsChange(newPerPage, page) {
        setActivePage(page);
        setPerPage(newPerPage);
    }


    async function getTableData() {
        loadingShow();
        let url = `${urlApi.getInstructionOfUser}${orgID}?page=${activePage}&limit=${perPage}`;
        let resp = await getApi(url);
        console.log(resp);
        loadingHide();
        if (resp.responseCode === 200) {
            setTableData({
                data: resp.data?.items,
                totalCount: resp.data?.count
            })
        } else {
            setTableData({
                data: [],
                totalCount: 0
            });
            toast.error(resp.message);
        }
    }


    const handleDeleteInstruction = async (row) => {
        loadingShow();
        let url = `${urlApi.deleteInstructionOfUser}${orgID}/${row._id}`;
        let resp = await getApi(url);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            getTableData();
        } else {
            toast.error(resp.message);
        }
    }



    useEffect(() => {
        if (show) {
            getTableData();
        }
        return () => { }
    }, [orgID, show, activePage, perPage]);




    const columns = [
        { name: "Sl. No", center: "true", width: "60px", selector: (row) => row?._id, cell: (row, index) => (index + 1) },
        {
            name: "Input Message", center: "true", selector: (row) => row?.inputMessage, cell: (row) => (

                <div className='flex items-center gap-2 py-2'>
                    <p className="mb-0.5 font-semibold text-sm text-primary py-3">{row?.inputMessage}</p>
                </div>
            ),
        },
        { name: "Output Message", center: "true", selector: (row) => row?.outputMessage, cell: (row) => (<p className="mb-0.5 font-semibold text-sm text-primary py-3">{row?.outputMessage}</p>), },
        {
            name: "Media Type",
            center: "true",
            cell: (row) => (
                row?.mediaType == "image" ? <span className="text-green-500 font-semibold">Image</span> : <span className="text-gray-500 font-semibold">Video</span>
            )
        },
        {
            name: "Image",
            center: "true",
            cell: (row) => (
                row?.mediaLink ? <img src={row?.mediaLink} alt="Instruction" className="w-20 h-20 p-3 object-cover rounded-md mx-auto" /> : row?.mediaLink == "video" ? <video controls className="w-full max-h-60 rounded-lg border">
                    <source src={row?.mediaLink} type="video/mp4" className='w-7 h-7' />
                    Your browser does not support the video tag.
                </video> : <span className="text-gray-500 font-semibold">N/A</span>
            )
        },

        {
            name: "Action",
            center: "true",
            cell: (row) => (
                <div className="flex flex-wrap gap-2 items-center justify-center">
                    <ConfirmationModal
                        buttonComponent={
                            <IconTrash
                                color="red"
                                className="cursor-pointer hover:bg-slate-200 rounded-full"
                            />
                        }
                        confirmationText="Are you sure you want to delete this instruction? This action cannot be undone."
                        onConfirm={() => handleDeleteInstruction(row)}
                    />
                </div>
            ),
        }
    ];
    return (
        <>
            <button
                onClick={handleShow}
                className="p-2 rounded-full bg-slate-200 hover:bg-slate-400 transition"
                title="Prompt Information"
            >
                <IconTerminal2 size={20} className="text-black" />
            </button>

            <Modal show={show} onHide={handleClose} backdrop="static" size="lg" centered>
                <Modal.Body className="rounded-xl p-6 bg-white shadow-lg">
                    {/* Header */}
                    <div className="flex justify-between items-center">
                        <h2 className="text-lg font-semibold text-gray-800">
                            Prompt Information Of {orgName}
                        </h2>
                        <IconX
                            className="cursor-pointer text-gray-500 hover:text-red-500 transition"
                            onClick={handleClose}
                        />
                    </div>

                    <hr className="my-4 border-gray-200" />

                    <TableComponent
                        columns={columns}
                        data={tableData.data}
                        totalRows={tableData.totalCount}
                        isPagination={true}
                        handlePageChange={(e) => handlePageChange(e)}
                        handlePerRowsChange={(newPerPage, page) => handlePerRowsChange(newPerPage, page)} />

                    {/* Footer */}
                    <div className="flex gap-2 justify-end mt-2">
                        <button
                            className="px-5 py-2 border rounded-md text-gray-600 hover:bg-gray-100 transition"
                            onClick={handleClose}
                        >
                            Close
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default AddPromptResponse